import { combineReducers } from '@ngrx/store';
import { blackDiamondImportHoldings } from './bd-import-holdings/import-holdings.reducer';
import { orionImportHoldings } from './orion_import_holdings/import-holdings.reducer';
import { pershingImportHoldings } from './pershing-import-holdings/reducer';
import { redtailImportHoldings } from './redtail-import-holdings/import-holdings.reducer';
import { vrglImportHoldings } from './vrgl-import-holdings/reducer';
import { addeparImportHoldings } from 'IntegrationsApp/ts/features/integrations-shared/state/addepar-import-holdings/import-holdings.reducer';
import { advyzonImportHoldings } from 'IntegrationsApp/ts/features/integrations-shared/state/advyzon-import-holdings/reducer';
import { avisoImportHoldings } from 'IntegrationsApp/ts/features/integrations-shared/state/aviso-import-holdings/reducer';
import { broadridgeImportHoldings } from 'IntegrationsApp/ts/features/integrations-shared/state/broadridge-import-holdings/import-holdings.reducer';
import { emoneyImportHoldings } from 'IntegrationsApp/ts/features/integrations-shared/state/emoney-import-holdings/reducer';
import { fidelityImportHoldings } from 'IntegrationsApp/ts/features/integrations-shared/state/fidelity-import-holdings/reducer';
import { hartfordImportHoldings } from 'IntegrationsApp/ts/features/integrations-shared/state/hartford-import-holdings/reducer';
import { isCustomSecurity } from 'IntegrationsApp/ts/features/integrations-shared/state/is-custom-security/is-custom-security.reducer';
import { lplImportHoldings } from 'IntegrationsApp/ts/features/integrations-shared/state/lpl-import-holdings/reducer';
import { northwesternMutualImportHoldings } from 'IntegrationsApp/ts/features/integrations-shared/state/northwestern-mutual-import-holdings/reducer';
import { raymondJamesImportHoldings } from 'IntegrationsApp/ts/features/integrations-shared/state/raymond-james-import-holdings/reducer';
import { schwabImportHoldings } from 'IntegrationsApp/ts/features/integrations-shared/state/schwab-import-holdings/import-holdings.reducer';
export const INTEGRATIONS_STATE_SLICE_KEY = 'importHoldings';
export const importHoldingsReducer = combineReducers({
    addeparImportHoldings,
    advyzonImportHoldings,
    avisoImportHoldings,
    blackDiamondImportHoldings,
    broadridgeImportHoldings,
    emoneyImportHoldings,
    fidelityImportHoldings,
    hartfordImportHoldings,
    lplImportHoldings,
    orionImportHoldings,
    pershingImportHoldings,
    redtailImportHoldings,
    schwabImportHoldings,
    vrglImportHoldings,
    raymondJamesImportHoldings,
    northwesternMutualImportHoldings,
    isCustomSecurity,
});
